import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by
 * `createOrganization`/`updateOrganization`/`deleteOrganization`. The list fetch's own failure
 * (`ORGANIZATIONS_FETCH_FAILED`) is deliberately not covered here (as are the logo fetch failures,
 * shown inline by the card and the sidebar): the page surfaces it inline, as the empty state's
 * description, rather than as a toast.
 */
const OrganizationsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="ORGANIZATION_CREATED"
				title="Structure créée"
				message="La structure a bien été créée."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_UPDATED"
				title="Structure modifiée"
				message="La structure a bien été modifiée."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_DELETED"
				title="Structure supprimée"
				message="La structure a bien été supprimée."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_CREATION_FAILED"
				title="Erreur"
				message="La structure n’a pas pu être créée."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_UPDATE_FAILED"
				title="Erreur"
				message="La structure n’a pas pu être modifiée."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_DELETION_FAILED"
				title="Erreur"
				message="La structure n’a pas pu être supprimée."
			/>
			<SuccessNotification
				eventName="ACCOUNT_LOGO_REPLACED"
				title="Logo enregistré"
				message="Le logo a bien été enregistré."
			/>
			<SuccessNotification
				eventName="ACCOUNT_LOGO_REMOVED"
				title="Logo retiré"
				message="Le logo a bien été retiré."
			/>
			<ErrorNotification
				eventName="ACCOUNT_LOGO_REPLACEMENT_FAILED"
				title="Erreur"
				message="Le logo n'a pas pu être enregistré"
			/>
			<ErrorNotification
				eventName="ACCOUNT_LOGO_REMOVAL_FAILED"
				title="Erreur"
				message="Le logo n'a pas pu être retiré"
			/>
			<SuccessNotification
				eventName="ORGANIZATION_LOGO_REPLACED"
				title="Logo enregistré"
				message="Le logo a bien été enregistré."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_LOGO_REMOVED"
				title="Logo retiré"
				message="Le logo a bien été retiré."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_LOGO_REPLACEMENT_FAILED"
				title="Erreur"
				message="Le logo n'a pas pu être enregistré"
			/>
			<ErrorNotification
				eventName="ORGANIZATION_LOGO_REMOVAL_FAILED"
				title="Erreur"
				message="Le logo n'a pas pu être retiré"
			/>
		</React.Fragment>
	);
};

export default OrganizationsNotifications;
